import ResetPassword from '@shared/components/auth/ResetPassword';
import * as Actions from '@/app/store/actions';
import * as authActions from '@/app/auth/store/actions';
import { useDispatch } from 'react-redux';
import { resetPassword } from '../../../../services/resetPassword/resetPassword';
import { useState, useEffect } from 'react';
import JwtService from '@/app/services/jwtService';
import { useNavigate, useLocation } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const ResetPasswordPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [username] = useState(location?.search?.split('=')[1]);

	useEffect(() => {
		if (!username) {
			dispatch(
				Actions.showMessage({
					message: 'Please enter Email/Phone to receive OTP.',
					variant: 'error',
					autoHideDuration: 3000,
				})
			);
			// navigate('/forgot-password');
		}
	}, [dispatch, username]);

	const handleSuccess = (message) => {
		JwtService.setSession(null);
		secureLocalStorage.removeItem('needs_password_reset');
		dispatch(authActions.removeUserData());
		dispatch(
			Actions.showMessage({
				message: `${message}. Redirecting...`,
				variant: 'success',
				autoHideDuration: 3000,
			})
		);
		navigate('/success');
	};

	const handleError = (message) => {
		dispatch(
			Actions.showMessage({
				message,
				variant: 'error',
				autoHideDuration: 3000,
			})
		);
	};

	const handleResetPassword = async (data) => {
		return resetPassword({
			...data,
			username,
		});
	};

	return (
		<div className="min-h-screen flex items-center justify-center p-4 bg-[url('/assets/images/banner/bg.png')] bg-no-repeat bg-center bg-cover w-screen">
			<ResetPassword onError={handleError} onResetPassword={handleResetPassword} onSuccess={handleSuccess} />
		</div>
	);
};

export default ResetPasswordPage;
